import { type ReactNode } from 'react';
import styles from './Banner.module.css';

interface BannerProps {
  variant?: 'info' | 'warning' | 'success' | 'danger';
  title?: string;
  children?: ReactNode;
  action?: ReactNode;
}

export function Banner({ variant = 'info', title, children, action }: BannerProps): JSX.Element {
  return (
    <div className={`${styles.banner} ${styles[`v_${variant}`]}`} role="status">
      <div className={styles.body}>
        {title && <div className={styles.title}>{title}</div>}
        {children && <div className={styles.text}>{children}</div>}
      </div>
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
